import CategoryMenuController from './category-menu-controller'

export default CategoryMenuController
